import { Alert, type AlertColor, AlertTitle, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps, Text } from "@src/appV2/redesign/system/ui-components";

export interface SimpleAlertProps {
  title: string;
  description: string;
  severity?: AlertColor;
  sx?: SxProps<Theme>;
}

function getIntentPalette(theme: Theme, severity: AlertColor) {
  switch (severity) {
    case "info":
      return theme.palette.intent?.neutral;
    case "warning":
      return theme.palette.intent?.warning;
    case "error":
      return theme.palette.intent?.error;
    case "success":
      return theme.palette.intent?.success;
  }
}

export function SimpleAlert(props: SimpleAlertProps) {
  const { title, description, severity = "info", sx } = props;

  return (
    <Alert
      severity={severity}
      icon={false}
      sx={mergeSxProps((theme) => {
        const intent = getIntentPalette(theme, severity);
        return {
          backgroundColor: intent?.background,
          border: `1px solid ${intent?.border ?? "transparent"}`,
          borderRadius: theme.borderRadius?.medium,
        };
      }, sx)}
    >
      <AlertTitle
        sx={(theme) => ({
          fontWeight: "bold",
          color: getIntentPalette(theme, severity)?.text,
        })}
      >
        {title}
      </AlertTitle>
      <Text variant="body2" sx={{ color: "text.secondary" }}>
        {description}
      </Text>
    </Alert>
  );
}
